import type Immutable from 'immutable';

import { OrganizationType } from '../organization';
import {
  getOrganizationId,
  getOrganizationType,
} from '../organization/OrganizationImmutable';
import type { OrganizationImmutable } from '../organization/immutable';

import type { User } from './User';
import { UserType } from './UserType';

export interface UserImmutable
  extends Immutable.Map<keyof User, any | undefined> {
  toJS(): User;
  get<K extends keyof User>(key: K): User[K];
}

export const getUserType = (user: UserImmutable): User['type'] =>
  user?.get('type');

export const isUserSuperAdmin = (user: UserImmutable): boolean =>
  [UserType.SERVICE, UserType.SUPER_ADMIN].includes(getUserType(user));

export const getUserOrganization = (
  user: UserImmutable,
): OrganizationImmutable => user?.getIn(['belongsTo', 0]);

export const getUserOrganizationId = (user: UserImmutable): number =>
  getOrganizationId(getUserOrganization(user));

export const getUserOrganizationType = (
  user: UserImmutable,
): OrganizationType => getOrganizationType(getUserOrganization(user));

export const isUserManufacturer = (user: UserImmutable): boolean =>
  getUserOrganizationType(user) === OrganizationType.MANUFACTURER;

export const isUserRetailer = (user: UserImmutable): boolean =>
  getUserOrganizationType(user) === OrganizationType.RETAILER;

export const isUserPrivateLabel = (user: UserImmutable): boolean =>
  getUserOrganizationType(user) === OrganizationType.PRIVATE_LABEL;

export const isUserThirdParty = (user: UserImmutable): boolean =>
  getUserOrganizationType(user) === OrganizationType.THIRD_PARTY;
